/* ==========================================================================
   CALI: Compact header search toggle (Oct 2026)
   Loaded only when Header > Desktop layout = "Compact".
   - Search icon opens the search bar under the header; clicking it again closes it
   - Also closes on Escape or a click outside the header
   - Delegated listeners, so it keeps working after theme-editor section reloads
   ========================================================================== */
(function () {
  'use strict';

  if (window.__caliHeaderCompactBound) return;
  window.__caliHeaderCompactBound = true;

  function getHeader() {
    return document.querySelector('.main-header--compact');
  }

  function parts() {
    var header = getHeader();
    if (!header) return null;
    return {
      header: header,
      panel: header.querySelector('[data-cali-hc-search]'),
      button: header.querySelector('[data-cali-hc-search-toggle]'),
      input: header.querySelector('[data-cali-hc-search] input[name="q"]')
    };
  }

  function isOpen() {
    var p = parts();
    return !!(p && p.panel && !p.panel.hidden);
  }

  function open() {
    var p = parts();
    if (!p || !p.panel) return;
    p.panel.hidden = false;
    p.header.classList.add('cali-hc-search-open');
    if (p.button) {
      p.button.setAttribute('aria-expanded', 'true');
      p.button.setAttribute('aria-label', 'Close search');
    }
    if (p.input) {
      p.input.classList.remove('hidden');
      p.input.setAttribute('aria-hidden', 'false');
      try { p.input.focus({ preventScroll: true }); } catch (e) { p.input.focus(); }
    }
  }

  function close(returnFocus) {
    var p = parts();
    if (!p || !p.panel || p.panel.hidden) return;
    if (p.input) p.input.blur();
    p.panel.hidden = true;
    p.header.classList.remove('cali-hc-search-open');
    if (p.button) {
      p.button.setAttribute('aria-expanded', 'false');
      p.button.setAttribute('aria-label', 'Search');
      if (returnFocus) {
        try { p.button.focus({ preventScroll: true }); } catch (e) {}
      }
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-cali-hc-search-toggle]')) {
      event.preventDefault();
      if (isOpen()) { close(false); } else { open(); }
      return;
    }

    if (!isOpen()) return;

    // Leave it open for clicks inside the header or inside a search app's results dropdown
    if (target.closest('.main-header--compact')) return;
    if (target.closest('.snize-ac-results, .snize, [class*="snize-ac"]')) return;

    close(false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) close(true);
  });

  // Mobile has its own full-screen search, so close this one if the window shrinks
  var mq = window.matchMedia('(max-width: 720px)');
  var onChange = function (e) { if (e.matches) close(false); };
  if (mq.addEventListener) { mq.addEventListener('change', onChange); } else if (mq.addListener) { mq.addListener(onChange); }

  document.addEventListener('shopify:section:unload', function () { close(false); });
})();
